import { RefObject, useCallback } from "react"
import { buildChatCaseSummaryTrackingMetadata, useChatCaseSummary } from "@/modules/chats/hooks/useChatCaseSummary"
import { useReadChatHistory, useResetChatHistoryTo } from "@/modules/chats/hooks/useChatHistory"
import { useChatInputContext } from "@/modules/chats/stores/useChatInputStore"
import { ChatThread } from "@/modules/chats/types/chat-thread"

export const useChatSummaryPrefill = (
  selectedThread: ChatThread,
  cancelledRef: RefObject<boolean>,
): (() => Promise<void>) => {
  const runChatCaseSummary = useChatCaseSummary(selectedThread, cancelledRef)
  const readChatHistory = useReadChatHistory()
  const resetHistoryTo = useResetChatHistoryTo()
  const setAiTrackingMetadata = useChatInputContext((store) => store.setAiTrackingMetadata)

  return useCallback(async () => {
    const result = await runChatCaseSummary()
    if (!result || cancelledRef.current) {
      return
    }

    const previousText = readChatHistory().at(-1)?.content ?? ""
    resetHistoryTo([{ content: result.text, aiFeatures: ["CHAT_CASE_SUMMARY_CONFIRMATION_MESSAGE"] }])
    setAiTrackingMetadata([buildChatCaseSummaryTrackingMetadata(result, previousText)])
  }, [runChatCaseSummary, cancelledRef, readChatHistory, resetHistoryTo, setAiTrackingMetadata])
}
